import * as types from '../types.js';

/**
 * Formulário de impressão — Romaneio de Transportadora (Doca Expedição).
 * Campos de motorista/placa/data são opcionais (saem em branco no PDF para preenchimento manual).
 */
export default {

	html: `
		<style>
			#dock-romaneio #driver_name { width: 16rem; }
			#dock-romaneio #vehicle_plate { width: 8rem; }
			#dock-romaneio #driver_doc { width: 10rem; }
			#dock-romaneio #operation_nature { width: 10rem; }
			#dock-romaneio #departure_date { width: 8rem; }
			#dock-romaneio #departure_time { width: 6rem; }
			#dock-romaneio #notes { width: 28rem; }
		</style>
		<form id="dock-romaneio" class="form" autocomplete="off" novalidate>
			<div class="title">Romaneio de Transportadora</div>
			<p class="mts muted" style="max-width:36rem">
				Selecione <strong>todos</strong> os pedidos da coleta de uma vez. O PDF gera
				<strong>um romaneio por transportadora</strong> (vários pedidos na mesma folha),
				ordenados pelo número do <strong>Pedido</strong> (menor → maior).
				Motorista, placa e documentos podem ficar em branco para preenchimento na saída.
			</p>
			<div class="fsb mtl">
				<label title="Nome do motorista">Motorista
					<input id="driver_name" type="text" placeholder="Opcional">
				</label>
				<label title="Placa do veículo">Placa
					<input id="vehicle_plate" type="text" placeholder="ABC1D23">
				</label>
				<label title="CPF ou RG do motorista">CPF/RG
					<input id="driver_doc" type="text" placeholder="Opcional">
				</label>
			</div>
			<div class="fsb">
				<label title="Natureza da operação">Natureza
					<input id="operation_nature" type="text" value="VENDA">
				</label>
				<label title="Data de saída">Data saída
					<input id="departure_date" type="text" placeholder="dd/mm/aaaa">
				</label>
				<label title="Hora de saída">Hora
					<input id="departure_time" type="text" placeholder="HH:MM">
				</label>
			</div>
			<div class="fsb">
				<label title="Observação impressa no romaneio">Observação
					<input id="notes" type="text" placeholder="Opcional">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Imprimir</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#dock-romaneio',
		init(formset) {
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
			const now = new Date();
			const p = (n) => String(n).padStart(2, '0');
			formset.form.setValues({
				operation_nature: 'VENDA',
				departure_date: `${p(now.getDate())}/${p(now.getMonth() + 1)}/${now.getFullYear()}`,
				departure_time: `${p(now.getHours())}:${p(now.getMinutes())}`,
			});
			formset.form.refresh();
		},
	},

	fields: [
		{ properties: { selector: '#driver_name' }, types: [] },
		{ properties: { selector: '#vehicle_plate' }, types: [] },
		{ properties: { selector: '#driver_doc' }, types: [] },
		{ properties: { selector: '#operation_nature' }, types: [] },
		{ properties: { selector: '#departure_date' }, types: [] },
		{ properties: { selector: '#departure_time' }, types: [] },
		{ properties: { selector: '#notes' }, types: [] },
	],

};
